import request from './request'

export const getShopWalletRecharges = (params) => {
  return request({
    url: '/admin/shop-wallet/recharges',
    method: 'get',
    params
  })
}

export const approveShopWalletRecharge = (id, data = {}) => {
  return request({
    url: `/admin/shop-wallet/recharges/${id}/approve`,
    method: 'post',
    data
  })
}

export const rejectShopWalletRecharge = (id, data = {}) => {
  return request({
    url: `/admin/shop-wallet/recharges/${id}/reject`,
    method: 'post',
    data
  })
}
